import * as React from 'react'
import Row from 'src/packages/grid/Row'
import Col from 'src/packages/grid/Col'
import Code from 'src/components/Code'
import CodeBox from 'src/components/CodeBox'
import Space from 'src/components/Space'
import { renderString } from 'src/utils/renderCode'

const componentName = 'GridExample'

class GridExample extends React.Component {
  public static displayName = componentName

  public render() {
    return (
      <div className="grid-example">
        <section>
          <h1>Grid 栅格</h1>
          <p className="text">24格栅格系统。</p>
        </section>
        <section>
          <h2>何时使用</h2>
          <p className="text">快速实现响应式布局。</p>
        </section>
        <section>
          <h2>代码示例</h2>
        </section>
        <div className="example">
          <div className="container" style={{ display: 'block' }}>
            <Row>
              <Col span={12}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col-12
                </div>
              </Col>
              <Col span={12}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Col-12
                </div>
              </Col>
            </Row>
            <br />
            <Row>
              <Col span={8}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col-8
                </div>
              </Col>
              <Col span={8}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Col-8
                </div>
              </Col>
              <Col span={8}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col-8
                </div>
              </Col>
            </Row>
            <br />
            <Row>
              <Col span={6}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col-6
                </div>
              </Col>
              <Col span={6}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Col-6
                </div>
              </Col>
              <Col span={6}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col-6
                </div>
              </Col>
              <Col span={6}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Col-6
                </div>
              </Col>
            </Row>
          </div>
          <CodeBox
            title="基础栅格"
            description="使用 Row 和 Col 栅格组件，创建一个基本的栅格系统，所有 Col 必须放在 Row 内，Row 的直接子组件也只能是 Col。"
          >
            {renderString(`import { Row } from 'xue-react'`)}
            {renderString(`import { Col } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code code={`&lt;Row&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={12}&gt;Col-12&lt;/Col&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={12}&gt;Col-12&lt;/Col&gt;`} />
            <Code code={`&lt;/Row&gt;`} />
            <Code code={`&lt;Row&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={8}&gt;Col-8&lt;/Col&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={8}&gt;Col-8&lt;/Col&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={8}&gt;Col-8&lt;/Col&gt;`} />
            <Code code={`&lt;/Row&gt;`} />
            <Code code={`&lt;Row&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={6}&gt;Col-6&lt;/Col&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={6}&gt;Col-6&lt;/Col&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={6}&gt;Col-6&lt;/Col&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={6}&gt;Col-6&lt;/Col&gt;`} />
            <Code code={`&lt;/Row&gt;`} />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container" style={{ display: 'block' }}>
            <Row>
              <Col span={4}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col-4
                </div>
              </Col>
              <Col span={4} offset={1}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Col-4
                </div>
              </Col>
              <Col span={4} offset={3}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col-4
                </div>
              </Col>
              <Col span={4} offset={4}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Col-4
                </div>
              </Col>
            </Row>
          </div>
          <CodeBox
            title="区块偏移"
            description="使用 offset 属性使区块向右侧偏移。"
          >
            {renderString(`import { Row } from 'xue-react'`)}
            {renderString(`import { Col } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code code={`&lt;Row&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={4}&gt;Col-4&lt;/Col&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={4} offset={1}&gt;Col-4&lt;/Col&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={4} offset={3}&gt;Col-4&lt;/Col&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={4} offset={4}&gt;Col-4&lt;/Col&gt;`} />
            <Code code={`&lt;/Row&gt;`} />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container" style={{ display: 'block' }}>
            <Row gutter={10}>
              <Col span={6}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col-6
                </div>
              </Col>
              <Col span={6}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Col-6
                </div>
              </Col>
              <Col span={6}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col-6
                </div>
              </Col>
              <Col span={6}>
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Col-6
                </div>
              </Col>
            </Row>
          </div>
          <CodeBox
            title="区块间隔"
            description="使用 gutter 属性设置区块间隔。"
          >
            {renderString(`import { Row } from 'xue-react'`)}
            {renderString(`import { Col } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code code={`&lt;Row gutter={10}&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={6}&gt;Col-6&lt;/Col&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={6}&gt;Col-6&lt;/Col&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={6}&gt;Col-6&lt;/Col&gt;`} />
            <Space count={4} />
            <Code code={`&lt;Col span={6}&gt;Col-6&lt;/Col&gt;`} />
            <Code code={`&lt;/Row&gt;`} />
          </CodeBox>
        </div>
        <div className="example">
          <div className="container" style={{ display: 'block' }}>
            <Row gutter={4}>
              <Col
                span={12}
                sm={{ span: 7 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
                xl={{ span: 3 }}
              >
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col
                </div>
              </Col>
              <Col
                span={12}
                sm={{ span: 7 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
                xl={{ span: 3 }}
              >
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Col
                </div>
              </Col>
              <Col
                span={12}
                sm={{ span: 7 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
                xl={{ span: 3 }}
              >
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col
                </div>
              </Col>
              <Col
                span={12}
                sm={{ span: 7 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
                xl={{ span: 3 }}
              >
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Col
                </div>
              </Col>
              <Col
                span={12}
                sm={{ span: 7 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
                xl={{ span: 3 }}
              >
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col
                </div>
              </Col>
              <Col
                span={12}
                sm={{ span: 7 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
                xl={{ span: 3 }}
              >
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Col
                </div>
              </Col>
              <Col
                span={12}
                sm={{ span: 7 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
                xl={{ span: 3 }}
              >
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#40a9ff' }}
                >
                  Col
                </div>
              </Col>
              <Col
                span={12}
                sm={{ span: 7 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
                xl={{ span: 3 }}
              >
                <div
                  className="grid-demo"
                  style={{ backgroundColor: '#1890ff' }}
                >
                  Col
                </div>
              </Col>
            </Row>
          </div>
          <CodeBox
            title="响应式布局"
            description="span 和 offset 默认所有宽度下生效，具体设置见 Options，设置 sm、md、lg、xl 属性覆盖以实现响应式布局。"
          >
            {renderString(`import { Row } from 'xue-react'`)}
            {renderString(`import { Col } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code code={`&lt;Row gutter={4}&gt;`} />
            <Space count={4} />
            <Code
              code={`&lt;Col span={12}  sm={sm} md={md} lg={lg} xl={xl}&gt;Col&lt;/Col&gt;`}
            />
            <Space count={4} />
            <Code
              code={`&lt;Col span={12}  sm={sm} md={md} lg={lg} xl={xl}&gt;Col&lt;/Col&gt;`}
            />
            <Space count={4} />
            <Code
              code={`&lt;Col span={12}  sm={sm} md={md} lg={lg} xl={xl}&gt;Col&lt;/Col&gt;`}
            />
            <Space count={4} />
            <Code
              code={`&lt;Col span={12}  sm={sm} md={md} lg={lg} xl={xl}&gt;Col&lt;/Col&gt;`}
            />
            <Space count={4} />
            <Code
              code={`&lt;Col span={12}  sm={sm} md={md} lg={lg} xl={xl}&gt;Col&lt;/Col&gt;`}
            />
            <Space count={4} />
            <Code
              code={`&lt;Col span={12}  sm={sm} md={md} lg={lg} xl={xl}&gt;Col&lt;/Col&gt;`}
            />
            <Space count={4} />
            <Code
              code={`&lt;Col span={12}  sm={sm} md={md} lg={lg} xl={xl}&gt;Col&lt;/Col&gt;`}
            />
            <Space count={4} />
            <Code
              code={`&lt;Col span={12}  sm={sm} md={md} lg={lg} xl={xl}&gt;Col&lt;/Col&gt;`}
            />
            <Code code={`&lt;/Row&gt;`} />
          </CodeBox>
        </div>
        <section>
          <h2>API</h2>
        </section>
        <section className="sub">
          <h3>Row</h3>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>gutter</td>
              <td className="des">栅格间隔，单位：px</td>
              <td className="type">number</td>
              <td>——</td>
            </tr>
            <tr>
              <td>className</td>
              <td className="des">自定义 Row 类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>style</td>
              <td className="des">自定义 Row 样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
          </tbody>
        </table>
        <section className="sub">
          <h3>Col</h3>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>span</td>
              <td className="des">
                栅格占位格数，设置为 0 时相当于设置 display: none
              </td>
              <td className="type">number</td>
              <td>——</td>
            </tr>
            <tr>
              <td>offset</td>
              <td className="des">栅格向右偏移的格数</td>
              <td className="type">number</td>
              <td>0</td>
            </tr>
            <tr>
              <td>sm</td>
              <td className="des">
                响应式栅格，> 576px 生效，具体属性设置见 Options
              </td>
              <td className="type">Options</td>
              <td>——</td>
            </tr>
            <tr>
              <td>md</td>
              <td className="des">
                响应式栅格，> 768px 生效，具体属性设置见 Options
              </td>
              <td className="type">Options</td>
              <td>——</td>
            </tr>
            <tr>
              <td>lg</td>
              <td className="des">
                响应式栅格，> 992px 生效，具体属性设置见 Options
              </td>
              <td className="type">Options</td>
              <td>——</td>
            </tr>
            <tr>
              <td>xl</td>
              <td className="des">
                响应式栅格，> 1200px 生效，具体属性设置见 Options
              </td>
              <td className="type">Options</td>
              <td>——</td>
            </tr>
            <tr>
              <td>className</td>
              <td className="des">自定义 Col 类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>style</td>
              <td className="des">自定义 Col 样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
          </tbody>
        </table>
        <section className="sub">
          <h3>Options</h3>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>参数</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>span</td>
              <td className="des">
                栅格占位格数，设置为 0 时相当于设置 display: none
              </td>
              <td className="type">number</td>
              <td>——</td>
            </tr>
            <tr>
              <td>offset</td>
              <td className="des">栅格向右偏移的格数</td>
              <td className="type">number</td>
              <td>0</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default GridExample



// WEBPACK FOOTER //
// ./src/examples/Grid.example.tsx